export interface Task {
  id: string;
  title: string;
  description: string;
  assignedTo: string;
  businessUnit: BusinessUnit;
  urgent: boolean;
  status: TaskStatus;
  createdBy: string;
  created: string;
  dueDate?: string;
  priority?: TaskPriority;
  tags?: string[];
  attachments?: TaskAttachment[];
}

export interface TaskComment {
  id: string;
  taskId: string;
  comment: string;
  mentioned: string[];
  createdBy: string;
  created: string;
  authorDisplayName?: string;
  authorEmail?: string;
}

export interface TaskAttachment {
  id: string;
  name: string;
  url: string;
  size: number;
  uploadedBy: string;
  uploadedDate: string;
}

export enum TaskStatus {
  OPEN = 'Open',
  IN_PROGRESS = 'In Progress',
  COMPLETE = 'Complete',
  ON_HOLD = 'On Hold',
  CANCELLED = 'Cancelled'
}

export enum TaskPriority {
  LOW = 'Low',
  MEDIUM = 'Medium',
  HIGH = 'High',
  URGENT = 'Urgent'
}

export enum BusinessUnit {
  CLINICAL_OPERATIONS = 'Clinical Operations',
  FINANCE_DEVELOPMENT = 'Finance & Development',
  LEHR = 'LEHR',
  SUPPORT_SERVICES = 'Support Services',
  TECHNOLOGY = 'Technology',
  COMMUNICATIONS = 'Marketing and Communications'
}

export enum UserRole {
  EXECUTIVE = 'Executive',
  MANAGER = 'Manager',
  STAFF = 'Staff'
}

export interface TaskFilter {
  status?: TaskStatus[];
  businessUnit?: BusinessUnit[];
  assignedTo?: string[];
  urgent?: boolean;
  createdBy?: string[];
  dateRange?: {
    start: string;
    end: string;
  };
}

export interface TaskGroup {
  key: string;
  label: string;
  tasks: Task[];
  count: number;
}

export interface TaskNotification {
  id: string;
  taskId: string;
  userId: string;
  type: 'assignment' | 'mention' | 'status_change' | 'comment';
  message: string;
  read: boolean;
  created: string;
}

export interface TaskDashboardStats {
  totalTasks: number;
  openTasks: number;
  inProgressTasks: number;
  completedTasks: number;
  urgentTasks: number;
  overdueTasks: number;
  myTasks: number;
  assignedByMe: number;
} 